/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const ContactAPI = {
  getContact: async(contactId: string) =>
    (await initAxios())?.get(`/contacts/${contactId}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getContactsByGroupId: async(groupId: string, contactType?: string) => {
    const query = contactType ? `?type=${encodeURIComponent(contactType)}` : '';
    return (await initAxios())?.get(`/contacts/group/${groupId}${query}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      });
  },

  createContact: async(contactBody: any) =>
    (await initAxios())?.post('/contacts', JSON.stringify(contactBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateContact: async(contactId: string, contactBody: any) =>
    (await initAxios())?.put(`/contacts/${contactId}`, JSON.stringify(contactBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteContact: async(contactId: string) =>
    (await initAxios())?.delete(`/contacts/${contactId}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default ContactAPI;
